import type { FC, ReactNode } from 'react'

import { Loader2 } from 'lucide-react'

// Shown while the page is waiting for its inventory data, for example during a
// live code update in the editor before the fresh data has arrived.
const HallLoading: FC = (): ReactNode => {
    return (
        <div className='hall-backdrop flex h-dvh w-full flex-col items-center justify-center gap-4 text-slate-300' role='status' aria-live='polite'>
            <Loader2 className='size-6 animate-spin text-cyan-300' aria-hidden='true' />
            <p className='text-sm tracking-wide'>
                Loading the data hall
            </p>
        </div>
    )
}

export default HallLoading
